import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, ModalBody, ModalFooter, Col, Row, Container } from 'reactstrap';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './EmissoesExclusao.scss';

class EmissoesExclusao extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			isOpen: false,
		};
	}

	excluirSelecionadas = () => {
		this.onLoading(true);

		const removeInfo = {
			id: localStorage.getItem('CodUsuario'),
			listRemove:this.props.value,
			statusRemove: this.props.status
		};

		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/RemoverListaStatus`, removeInfo)
			.then(response => {
				this.onLoading(false);
				const { data } = response;
				
				if (!data.error) {
					this.showSuccessMessage('Sua solicitação foi enviada e a exclusão das guias está sendo processada. Isso pode levar alguns minutos. Fique à vontade para explorar nosso sistema.');
					
				} else {
					this.showErrorMessage('Ocorreu um erro ao excluir documentos');
				}
				
				//this.closeModal();
				setTimeout(() => {
					this.closeModal();
					// window.location.reload(true);
				}, 4000);
				//window.location.reload(true);
			})
			.catch(() => {
				this.onLoading(false);
				this.showErrorMessage('Erro inesperado ao excluir documentos');
			});
	};

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	render() {
		const { value } = this.props;
 
		return (
			<Modal
				//size="lg"
				id="modal-emissoes-exclusao"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.props.onClosed}
				backdrop="static">
				<AlertasContext.Consumer>
					{alertas => {
						this.showInfoMessage = alertas.info;
						this.showSuccessMessage = alertas.success;
						this.showWarningMessage = alertas.warning;
						this.showErrorMessage = alertas.error;
					}}
				</AlertasContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<ModalBody>
					<p>Você vai excluir {value.length} arquivo(s) permanentemente.</p>
					<p className="font-weight-bold">Tem certeza que deseja excluir este(s) registro(s)?</p>
				</ModalBody>
				<ModalFooter>
					<Container>
						<Row className="justify-content-around">
							<Col xs="auto">
								<Button color="info" onClick={() => this.closeModal()}>
									Não..
								</Button>
							</Col>
							<Col xs="auto">
								<Button color="primary" onClick={() => this.excluirSelecionadas()}>
									Sim, quero EXCLUIR TODOS
								</Button>
							</Col>
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	}
}

EmissoesExclusao.propTypes = {
	value: PropTypes.array,
	onClosed: PropTypes.func.isRequired,
};

export default EmissoesExclusao;
